import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/advice-button/advice-button.js';
      import {AdviceButtonClickEvent, AdviceButtonStyle} from '@oicl/openbridge-webcomponents/dist/components/advice-button/advice-button.js';

      export interface Props {
     buttonStyle?: AdviceButtonStyle;
     count?: number;
     showCount?: boolean;
     isActive?: boolean;
     ariaLabel?: string
   }

      
  
      export type {AdviceButtonClickEvent, AdviceButtonStyle} from '@oicl/openbridge-webcomponents/dist/components/advice-button/advice-button.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcAdviceButton',
  props: {
    buttonStyle: {},
    count: {},
    showCount: { type: Boolean },
    isActive: { type: Boolean },
    ariaLabel: {}
  },
  emits: ["obc-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onObcClick: (event: AdviceButtonClickEvent) => emit('obc-click', event as AdviceButtonClickEvent)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-advice-button',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})